var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step section-title",class:[{ 'open' : _vm.step.showStep, 'incomplete' : !_vm.step.completed && !_vm.step.showStep }, _vm.getStepClass(_vm.step) ]},[_vm._v(" "+_vm._s(_vm.step.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }